const IconRoles = ({ className }) => {
    return (
        <svg
            width='32'
            height='28'
            viewBox='0 0 32 28'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path
                id='Define roles'
                d='M20.5001 14.75H20.5151M25.0001 14.75H25.0151M20.5001 20C22.0001 21.0005 23.5001 21.0005 25.0001 20M10.9482 19.223C10.7577 19.241 10.5665 19.2501 10.3752 19.25H8.12518C6.62875 19.2499 5.18636 18.6906 4.08104 17.6818C2.97571 16.6731 2.28723 15.2877 2.15068 13.7975L1.30018 4.5245C1.26201 4.10909 1.3109 3.69029 1.44371 3.29484C1.57653 2.89939 1.79036 2.53599 2.07155 2.22784C2.35273 1.91969 2.6951 1.67358 3.07677 1.50521C3.45844 1.33684 3.87102 1.24992 4.28818 1.25H14.2122C15.0078 1.25 15.7709 1.56607 16.3335 2.12868C16.8961 2.69129 17.2122 3.45435 17.2122 4.25M7.00012 7.25H7.01512M11.5001 7.25H11.5151M7.00012 13.2499C8.14612 12.4849 9.29212 12.3049 10.4366 12.7099M17.7882 8.75H27.7122C28.1293 8.74992 28.5419 8.83684 28.9236 9.00521C29.3053 9.17358 29.6476 9.41969 29.9288 9.72784C30.21 10.036 30.4238 10.3994 30.5567 10.7948C30.6895 11.1903 30.7384 11.6091 30.7002 12.0245L29.8497 21.2975C29.7131 22.7877 29.0247 24.1731 27.9193 25.1818C26.814 26.1906 25.3716 26.7499 23.8752 26.75H21.6252C20.1287 26.7499 18.6864 26.1906 17.581 25.1818C16.4757 24.1731 15.7872 22.7877 15.6507 21.2975L14.8002 12.0245C14.762 11.6091 14.8109 11.1903 14.9437 10.7948C15.0765 10.3994 15.2904 10.036 15.5715 9.72784C15.8527 9.41969 16.1951 9.17358 16.5768 9.00521C16.9584 8.83684 17.371 8.74992 17.7882 8.75Z'
                stroke='white'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default IconRoles;
